/* eslint-disable comma-dangle */
/* eslint-disable operator-linebreak */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';

const state = {
  data: [],
  years: [],
  authorities: [],
  selectedAuthority: null,
  selectedYear: null,
  loading: false,
  loadCheck: false,
};

const getters = {
  authorityList: (stateTree) => stateTree.authorities,
  yearList: (stateTree) => stateTree.years,
  getStatistic: (stateTree) =>
    stateTree.data.filter(
      (result) =>
        result.Year === stateTree.selectedYear &&
        result['Local Authority'] === stateTree.selectedAuthority,
    )[0],
  loadCheck: (stateTree) => stateTree.loadCheck,
  dataOptions: (stateTree) => (stateTree.data[0] ? stateTree.data[0] : {}),
  getSelectedYear: (stateTree) => stateTree.selectedYear,
  getSelectedAuthority: (stateTree) => stateTree.selectedAuthority,
};
const headers = {
  withCredentials: false,
  // live
  'api-key-id': process.env.VUE_APP_ID,
  'api-key-secret': process.env.VUE_APP_SECRET,
  // staging
  // "api-key-id": "fb6d2e42-f0c4-47cd-b843-7c36a1658885",
  // "api-key-secret": "d65ca26238281ed339e4adcb3e0d82d5ff15062dfd947d4e173e4de655509648"
};

const actions = {
  async fetchStatisticsData(v) {
    let query =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/45724cc2-0f99-4215-9c07-2c78dadd6075/latest/urql?';
    if (v.state.selectedYear && v.state.selectedAuthority) {
      const authority = v.state.selectedAuthority;
      const year = v.state.selectedYear;
      query += `limit(-1)&eq(Local Authority,${encodeURIComponent(authority)})&eq(Year,${year})`;
    }

    try {
      const response = await axios.get(query, {
        headers,
      });
      const { data } = response;
      v.commit('updateStatisticsData', data);
      return v.commit('toggleLoading', false);
    } catch (e) {
      console.error(' we got an error fetching data: ', e);
      v.commit('updateStatisticsData', []);
      return v.commit('toggleLoading', false);
    }
  },
  async fetchAuthorities({ commit }) {
    const query =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/45724cc2-0f99-4215-9c07-2c78dadd6075/latest/urql?';
    const distinct = 'distinct(Local Authority)';
    const response = await axios.get(`${query}&${distinct}&cache=true`, {
      headers,
    });
    const { data } = response;
    commit('updateAuthorities', data);
    commit('toggleLoading', false);
  },
  async fetchYears({ commit }) {
    const query =
      'https://api.usmart.io/org/d1b773fa-d2bd-4830-b399-ecfd18e832f3/45724cc2-0f99-4215-9c07-2c78dadd6075/latest/urql?';
    const distinct = 'distinct(Year)';
    const response = await axios.get(`${query}&${distinct}&cache=true`, {
      headers,
    });
    const { data } = response;
    commit('updateYears', data);
    commit('toggleLoading', false);
  },
};

const mutations = {
  toggleLoading(stateTree, payload) {
    stateTree.loading = payload;
  },
  updateStatisticsData(stateTree, payload) {
    stateTree.data = payload;
    stateTree.loadCheck = false;
  },
  updateAuthorities(stateTree, payload) {
    stateTree.authorities = payload.map((authority) => authority.key);
  },
  updateYears(stateTree, payload) {
    stateTree.years = payload.map((year) => year.key).sort((a, b) => b - a);
  },
  SET_YEAR(stateTree, payload) {
    stateTree.selectedYear = payload;
    if (stateTree.selectedAuthority) stateTree.loadCheck = true;
  },
  SET_AUTHORITY(stateTree, payload) {
    stateTree.selectedAuthority = payload;
    if (stateTree.selectedYear) stateTree.loadCheck = true;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
